export const split = <T>(array: T[]) => {
	const halves: [T[], T[]] = [[], []];

	array.forEach((el, i) => {
		halves[i % 2].push(el);
	});

	return halves;
};
